import React, { useEffect, useState } from 'react';
import {EuiFlexItem, EuiFlexGroup,EuiButton, EuiForm, EuiFormRow, EuiFieldText, EuiFieldPassword, EuiSelect, EuiProgress, EuiPanel } from '@elastic/eui';
import {SellerTable} from "./table/SellerTable";

interface User {
    userStatus: string;
    userId: number;
    profileName: string;
    distributorName: string;
    credits: number;
    pendingPayments: number;
}

const ManageSellerComponent: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState<User[]>([]);
    const [newUserName, setNewUserName] = useState('');
    const [newUserPassword, setNewUserPassword] = useState('');
    const [newUserRole, setNewUserRole] = useState('DISTRIBUTOR');
    const [isCreatingUser, setIsCreatingUser] = useState(false);

    const [userLoader,setUserLoader] = useState(false)


    const fetchUsers = async () => {
        if (users) {
            setIsLoading(true)
            try {

                const token = localStorage.getItem('token');
                const response = await fetch('/api/v1/prof/getallchild', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setUsers(data);
                } else {
                    console.error('API Error:', response.status);
                }
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setIsLoading(false);
            }
        }};
    useEffect(() => {


            fetchUsers();
        }, []);

    const createUser = async () => {
        setUserLoader(true)
        try {

            const token = localStorage.getItem('token');

            const requestBody = {
                username: newUserName,
                password: newUserPassword,
                role: newUserRole,
            };

            const response = await fetch('/api/v1/usercreation', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });

            if (response.ok) {

                alert('User created successfully!');
                setNewUserName('');
                setNewUserPassword('');
                setNewUserRole('DISTRIBUTOR');
                setUserLoader(false)
                refreshData()
            } else {
                console.error('API Error:', response.status);
                alert('Failed to create user.');
                setUserLoader(false)
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Failed to create user.');
            setUserLoader(false)
        } finally {
            setUserLoader(false)
            setIsCreatingUser(false);
        }
    };

    function refreshData() {
        fetchUsers();
    }

    return (
        <div>
            <div className="top-bar-inside">
                <div className="containeroftopbar">
                    <div className="logo-inside">Manage Seller</div>
                </div>
            </div>
            { userLoader ?   (<EuiProgress size="xs" color="accent" />):(  <EuiPanel style={{ margin: "3%" }}>
                <h2>Create New User</h2>
                <EuiForm>
                    <EuiFlexGroup direction="row" alignItems="center">
                        <EuiFlexItem>
                            <EuiFormRow label="User Name" display="row">
                                <EuiFieldText value={newUserName} onChange={(e) => setNewUserName(e.target.value)} />
                            </EuiFormRow>
                        </EuiFlexItem>
                        <EuiFlexItem>
                            <EuiFormRow label="Password" display="row">
                                <EuiFieldPassword
                                    value={newUserPassword}
                                    onChange={(e) => setNewUserPassword(e.target.value)}
                                    type="dual"
                                />
                            </EuiFormRow>
                        </EuiFlexItem>
                        <EuiFlexItem>
                            <EuiFormRow label="Role" display="row">
                                <EuiSelect
                                    options={[
                                        { value: 'DISTRIBUTOR', text: 'Distributor' },
                                        { value: 'SELLER', text: 'Seller' },
                                    ]}
                                    value={newUserRole}
                                    onChange={(e) => setNewUserRole(e.target.value)}
                                />
                            </EuiFormRow>
                        </EuiFlexItem>
                        <EuiFlexItem grow={false}>
                            <EuiFormRow display="row" style={{marginTop:"20px"}}>
                                <EuiButton onClick={createUser} isLoading={isCreatingUser} fill>
                                    Create User
                                </EuiButton>
                            </EuiFormRow>
                        </EuiFlexItem>
                    </EuiFlexGroup>
                </EuiForm>
            </EuiPanel>)}



            <EuiPanel style={{margin:"3%"}}>
                { isLoading?   (<EuiProgress size="xs" color="accent" />):(
                    < SellerTable batches={users} onSellerChildChange={refreshData}></SellerTable>)
                }
            </EuiPanel>
        </div>
    );
};

export default ManageSellerComponent;